import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Grid, Typography } from '@mui/material';
import { Image } from '../../../../../components';
import './VenueFeatures.scss';

function VenueFeaturesCheck({ features, onChangeState }) {
  const featuresFiltered = features.filter((i) => i.id !== 6);
  return (
    <Grid container justifyContent="space-between">
      <Grid sm={10}>
        {featuresFiltered.map(({ id, name, state, Icon }) => (
          <Grid
            item
            sm={12}
            key={id}
            marginBottom={1}
            justifyContent="flex-start"
            alignItems="center">
            {Icon && <Image src={Icon} className="venue-feature-icon" alt={name} />}
            <Checkbox
              id={id}
              checked={state}
              onChange={onChangeState}
              inputProps={{ 'aria-label': 'controlled' }}
            />
            <Typography variant="label">{name}</Typography>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}

VenueFeaturesCheck.propTypes = {
  onChangeState: PropTypes.func.isRequired,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      state: PropTypes.bool.isRequired,
    }).isRequired,
  ).isRequired,
};

export default VenueFeaturesCheck;
